import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

type SelectProps = {
  labelName: string
  register: any
  formValueSplit: any
  required?: any
}

const Select = ({ labelName, register, formValueSplit, required }: SelectProps) => {
  const { t } = useTranslation()
  return (
    <>
      <select {...register(labelName, { required })} className="c-select">
        <option value="">{t('common.select', '選択してください。')}</option>
        {formValueSplit.map((selectOption, i) => {
          return (
            <Fragment key={i}>
              <option value={`${selectOption}`}>{`${selectOption}`}</option>
            </Fragment>
          )
        })}
      </select>
    </>
  )
}

export default Select
